module.exports = __webpack_public_path__ + "img/newdoorbell.e36fdc4e.png";